// 缓存相关
// 请求session标记key
export const STORAGE_REQUEST_SESSION_KEY = '_rsk_';
// 请求session标记过期时间
export const REQUEST_SESSION_EXPIRE = 86400000; // 24h
// 分享详情页面的url
export const SHARE_DETAIL_URL_KEY = '_de_ur_';
// 是否已经授权过
export const IS_SYS_AUTH = '_sy_au_';
// 商品详情页url
export const ITEM_DETAIL_URL = '_de_ul_';
// banner详情页是否由首页进入
export const BANNER_DETAIL_FROM = '_BANNER_DETAIL_FROM_';
// 本次请求的orderId
export const REQUEST_SESSION_ORDERID = '_STORAGE_ORDER';

export const IS_TRANSITION = '_is_transition';

export const PAY_AFTER_URL = '_pay_after_url';

export const IS_RETAINED = '_is_retained';
export const USER_VERIFY_UUID = '_user_verify_uuid';

export const polarisAppIds = [
  'wx53aed20bd888a9a7', // 测试小程序appId 趣读西游体验课
  'wx8734de71e9438268' // 线上小程序appId 北极星伴读
];
